import type { PointTarget, GeometryElementDisplayConfig } from '../../../geometrypad.model';

// =============================================================================
// POINT
// =============================================================================

export interface PointElement {
  type: 'Point';
  params: PointTarget & { glideOn?: string };
}

// =============================================================================
// LINE
// =============================================================================

export interface LineElement {
  type: 'Line';
  params: {
    from: PointTarget;
    to: PointTarget;
  };
}

// =============================================================================
// POLYGON
// =============================================================================

export interface PolygonElement {
  type: 'Polygon';
  params: {
    vertices: PointTarget[];
  };
}

// =============================================================================
// DISPLAY DEFAULTS
// =============================================================================

/** Default display theme for standalone points. */
export const POINT_GEO_DEFAULTS: GeometryElementDisplayConfig = {
  point: { color: 'sky', size: 4 },
};

/** Default display theme for standalone lines. */
export const LINE_GEO_DEFAULTS: GeometryElementDisplayConfig = {
  line: { color: 'neutral', strokeWidth: 2 },
};

/** Default display theme for standalone polygons. */
export const POLYGON_GEO_DEFAULTS: GeometryElementDisplayConfig = {
  polygon: { fillColor: 'sky', fillOpacity: 0.1 },
  line: { strokeWidth: 2, color: 'neutral' },
};
